import '../../styles/game/GameRules.css';
import '../../styles/game/ProvablyFairSettings.css';
import '../../styles/game/AvatarChange.css';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';



function AvatarChangeModal({ isOpen, onClose, AvatarChangeModalOpen, isAvatar, setIsAvatar }) {
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();
    const [avatarList, setAvatarList] = useState([])

    useEffect(() => {
        const avatars = []
        for(let i = 1; i <= 72; i++) {
            avatars.push(`/assets/img/avatars/av-${i}.png`);
        }
        setAvatarList(avatars)

    }, [])

    useEffect(() => {
        if (isOpen) {
            setTimeout(() => setIsVisible(true), 10);
        } else {
            setIsVisible(false);
        }
    }, [isOpen]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);


    async function handleAvatarClick(src) {
        const token = await localStorage.getItem("token")
        if (!token) {
            return
        }
        setIsAvatar(src)
        try {
            const response = await fetch(`${import.meta.env.VITE_API_URL}/api/change-avatar`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`, // Передаем токен в заголовке
                  },
                body: JSON.stringify({ avatar: src }), // Отправляем путь к изображению
            });
            
            if (response.ok) {
                const data = await response.json();
                console.log("Аватар успешно обновлен:", data);
            } else {
                console.error("Ошибка при обновлении аватара:", response.status);
            }
        } catch (error) {
            console.error("Ошибка при отправке запроса:", error);
        }
        setTimeout(() => setIsVisible(false), 10);
        onClose();
    }


    return (
        <>
            <div className={`modalWrapper ${isVisible ? "show" : "fade-out"}`}
                 onClick={() => {
                     setTimeout(() => setIsVisible(false), 10);
                     onClose();
                 }}>
            </div>
            <div className={`gameRulesModal ${isVisible ? "show" : "fade-out"}`} onClick={() => {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }}>
                <div className={`provablyFairSettings ${isVisible ? "show" : "fade"}`}>
                    <div className={'gameRulesContent'} onClick={(e) => e.stopPropagation()}>
                        <div className={'gameRulesHeader'}>
                            <span>{t("chooseGameAvatar").toUpperCase()}</span>
                            <button className={'gameRulesCloseBtn'} onClick={() => {
                                setTimeout(() => setIsVisible(false), 10);
                                onClose();
                            }}>
                                <span>×</span>
                            </button>
                        </div>
                        <div className={'avatar-change-body-wrapper'}>
                            <div className='avatar-change-content'>
                            {avatarList.length > 0 && 
                                avatarList.map((src, index) => (
                                <img key={index} className={`avatar-img ${src === isAvatar ? "active" : ""}`} src={src} alt={`Avatar ${index}`} onClick={() => handleAvatarClick(src)} />
                                ))
                            }
                            
                            </div>
                        </div>
                        <div className={'provablyFairSettingsFooter'}>
                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AvatarChangeModal;